/**
 * init Accordion
 * @param accGroup
 */
window.initAccordion = function(accGroup) {
  if (accGroup.find('.accordion__item').length && !accGroup.hasClass('initialized')) {
    accGroup.find('.accordion__item').each(function() {
      const accItem = $(this);
      const accTrigger = accItem.children('.accordion__item__title:not(.form-submit)');
      const accBody = accItem.children('.accordion__item__body');

      // set display none for none active elements
      if (!accItem.hasClass('accordion__item--active')) {
        accBody.hide();
      }

      // click event
      if (accTrigger.length && accBody.length) {
        // reset bound click event just in case
        accTrigger.off('click');
        // bind new click event
        accTrigger.on('click', function() {
          if (!accTrigger.hasClass('form-submit')) {
            triggerAccordion(accTrigger);
          }
        });
      }

      // set initialized class
      accGroup.addClass('initialized');
    });
  }
};

/**
 * trigger Accordion
 * @param accTrigger
 */
window.triggerAccordion = function(accTrigger) {
  const accItem = accTrigger.parent('.accordion__item');
  const accGroup = accTrigger.closest('.accordion');

  // reset currently active items
  if (accGroup.find('.accordion__item.accordion__item--active').length) {
    accGroup.find('.accordion__item.accordion__item--active').removeClass('accordion__item--active').find('.accordion__item__body').stop().slideUp(200);
  }

  accItem.addClass('accordion__item--active').find('.accordion__item__body').stop().slideDown(200, function() {
    $(this).css('height', 'auto');

    const dataArea = accItem.data('area');
    const dataValue = accItem.data('accordion');
    if (dataArea) {
      fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveAccordion', {
        method: 'POST',
        body: JSON.stringify({
          dataArea: dataArea,
          dataValue: dataValue,
        }),
      }).then(function(response) {
        return response.text();
      });
    }
  });
};

window.resetAccordion = function(accGroup){
  if (accGroup.find('.accordion__item').length && accGroup.hasClass('initialized')) {
    accGroup.find('.accordion__item').each(function() {
      const accItem = $(this);
      const accTrigger = accItem.children('.accordion__item__title:not(.form-submit)');
      const accBody = accItem.children('.accordion__item__body');

      // click event
      if (accTrigger.length && accBody.length) {
        // reset bound click event just in case
        accTrigger.off('click');
      }

      // set initialized class
      accGroup.removeClass('initialized');
    });
  }
}